export const searchTypes = {
    text: 'text',
    movieHash: 'movieHash',
    flex: 'flex',
};